import React from 'react';
import { colors, IconButton, Popover as MaterialPopover, Typography } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';

const styles = (theme) => createStyles({
  titlePopover: {
    position    : "relative",
    paddingLeft : 10,
    display     : "inline-block",
    textAlign   : "right",
  },
  popoverBtn: {
    color         : colors.grey[600],
    fontSize      : 20,
    padding       : 0,
    verticalAlign : "top",
    zIndex        : 2,
  },
  popoverContent: {
    fontSize : 11,
    padding  : 5,
    maxWidth : 260,
  },
  fieldPopover: {
    position : "absolute",
    right    : 0,
  },
});

export class PopoverComponent extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  handleClick = (event) => {
    this.setState({
      open    : true,
      anchorEl: event.currentTarget,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    const { classes, text, isSummaryPage, fieldPopover } = this.props;
    const popoverClass = isSummaryPage || fieldPopover ? classes.fieldPopover : classes.titlePopover;
    return (
      <div className={popoverClass}>
        <IconButton
          aria-label = "Help"
          onClick    = {this.handleClick}
          className  = {classes.popoverBtn}
          tabIndex   = {-1}
        >
          <HelpIcon fontSize="inherit" />
        </IconButton>
        <MaterialPopover
          open       = {this.state.open}
          anchorEl   = {this.state.anchorEl}
          onClose    = {this.handleClose}
          anchorOrigin={{
            vertical  : 'top',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical  : 'bottom',
            horizontal: 'center',
          }}
        >
          <Typography className={classes.popoverContent}>{text}</Typography>
        </MaterialPopover>
      </div>
    );
  }
}

export const Popover = withStyles(styles)(PopoverComponent);
